import dynamic from "next/dynamic";

const GMapDynamic = dynamic(() => import("./gmap"), {
  ssr: false,
});

export default GMapDynamic;
